import React, { useEffect, useState } from 'react';
import { billingService } from '../../services/billingService';
import { logUiEvent } from '../../services/uiLogger';

// Сколько ждём активацию после возврата с платёжной формы: доставка события
// от шлюза асинхронная, обычно секунды, но по их расписанию ретраев может
// затянуться. Дальше не крутим — говорим правду и предлагаем обновить.
const POLL_MS = 3000;
const MAX_TRIES = 20;

/**
 * Итог оплаты после возврата с формы шлюза.
 *
 * Статус платежа сам по себе ничего не значит — клиенту важен тариф, поэтому
 * ждём не «оплачено», а появления подписки на оплаченном тарифе. Собственной
 * ручки статуса платежа для этого не заводим: подписка и есть бизнес-результат.
 */
export default function PaymentReturnBanner({ onDone }) {
  const [state, setState] = useState('waiting');   // waiting | activated | timeout
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    let alive = true;
    let tries = 0;

    const tick = async () => {
      if (!alive) return;
      tries += 1;
      try {
        const sub = await billingService.getMySubscription();
        if (!alive) return;
        if (sub && sub.plan_code && sub.plan_code !== 'free' && sub.status === 'active') {
          setPlan(sub.plan_name || sub.plan_code);
          setState('activated');
          logUiEvent('checkout_result', { component: 'pricing', meta: { result: 'activated' } });
          if (onDone) onDone();
          return;
        }
      } catch (e) {
        // Молчим: недоступность метрик подписки не повод пугать после оплаты
      }
      if (tries >= MAX_TRIES) {
        setState('timeout');
        logUiEvent('checkout_result', { component: 'pricing', meta: { result: 'timeout' } });
        return;
      }
      setTimeout(tick, POLL_MS);
    };

    tick();
    return () => { alive = false; };
  }, [onDone]);

  if (state === 'activated') {
    return (
      <div data-testid="payment-return" className="mb-4 rounded border bg-paper-success/[0.08] p-3 text-sm text-paper-accent">
        Оплата прошла, тариф «{plan}» активирован.
      </div>
    );
  }
  if (state === 'timeout') {
    return (
      <div data-testid="payment-return" className="mb-4 rounded border bg-paper-panel p-3 text-sm text-paper-accent">
        Платёж принят, но тариф ещё не активировался. Это может занять несколько минут —
        обновите страницу позже. Если ничего не изменится, напишите нам.
      </div>
    );
  }
  return (
    <div data-testid="payment-return" className="mb-4 rounded bg-paper-panel p-3 text-sm text-paper-ink-2">
      Проверяем оплату…
    </div>
  );
}
